import { useQuery } from '@tanstack/react-query';
import http from '../../api/http';

const fetchISNI = async () => {
  const {
    data: { data },
  } = await http.get('/user/user_isni');
  return data;
};
export const fetchRightsholderIsni = async (userId) => {
  const {
    data: { data },
  } = await http.get(`/user/rightsholder_isni/${userId}`);
  return data;
};
export const useFetchISNI = () => {
  return useQuery({
    queryKey: ['fetchISNI'],
    queryFn: fetchISNI,
  });
};
